module.exports = __webpack_public_path__ + "static/media/intro-video.91719b0f.png";